import { render, staticRenderFns } from "./supplierPrice.vue?vue&type=template&id=0d433881&scoped=true"
import script from "./supplierPrice.vue?vue&type=script&lang=js"
export * from "./supplierPrice.vue?vue&type=script&lang=js"
import style0 from "./supplierPrice.vue?vue&type=style&index=0&id=0d433881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d433881",
  null
  
)

export default component.exports